<template>
  <div>
    <el-table :data="tzReceiveRecord" stripe border style="width: 100%;height:100%">
      <el-table-column prop="create_user_name" label="接收人" width="180" />
      <el-table-column prop="receiveCnt" label="接收数量" width="150" />
      <el-table-column prop="returnCnt" label="退回数量" width="150" />
      <el-table-column prop="time" label="接收时间" width="150" />
      <el-table-column prop="ngReason" label="退回原因" width="200" />
      <el-table-column prop="remark" label="备注" />
    </el-table>
  </div>
  <div class="detail" v-show="tzReceiveRecord[0].pictures_pics_ids !== ''">
    <div class="nowrapDiv">
      <div class="fontBold">照片</div>
    </div>
    <el-image v-for="imageUrl in tzReceiveRecord[0].pictures_pics_list" :preview-src-list="tzReceiveRecord[0].pictures_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
  </div>
</template>

<script>
export default {
  name: "BusTzReceiveRecord",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return{
      tzReceiveRecord:[],
    }
  },
  methods:{
    async getTzReceiveRecord(){
      let {data: res} = await this.$axios.post('bus/tz/getTzReceiveRecord',this.parentData.id);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        this.tzReceiveRecord = res.data
      }
    }
  },
  created() {
    this.getTzReceiveRecord()
  }
}
</script>

<style scoped>

.detail {
  background-color: #FFFFFF;
  margin: 5px;
  border-radius: 5px;
  padding: 5px;
  font-size: 16px;
}

.nowrapDiv {
  display: flex;
  flex-wrap: nowrap;
}

.fontBold {
  font-weight: bold;
}

.imageStyle {
  width: 87px;
  height: 87px;
  margin-right: 5px
}
</style>